import { render, staticRenderFns } from "./project-merging.html?vue&type=template&id=0848cd20&"
import script from "./ProjectMerging.vue?vue&type=script&lang=js&"
export * from "./ProjectMerging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports